import { GETTING_NEW_LINK, SET_NEW_LINK_ERRORS, SAVE_NEW_PAYMENT_LINK, RESET_NEW_PAYMENT_LINK } from '../../../../types/conversations/plugins'

const newLinkInitialState = { gettingLink: false, errors: {}, link: '' }

export default function newLink(state = newLinkInitialState, action) {
  switch (action.type) {
    case SAVE_NEW_PAYMENT_LINK: {
      return Object.assign({}, state, { link: action.link })
    }
    case GETTING_NEW_LINK: {
      const { gettingLink } = action
      return Object.assign({}, state, { gettingLink })
    }
    case SET_NEW_LINK_ERRORS: {
      const { errors } = action
      return Object.assign({}, state, { errors })
    }
    case RESET_NEW_PAYMENT_LINK: {
      return newLinkInitialState
    }
    default: {
      return state
    }
  }
}
